import { OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewContainerRef } from '@angular/core';
import { NbAdjustment, NbDialogService, NbMenuBag, NbMenuItem, NbMenuService, NbOverlayService, NbPosition, NbPositionBuilderService } from '@nebular/theme';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { PopoverService } from '../dialogs/popover.service';

@Directive({
  selector: '[kveMenuItemPopover]',
  standalone: false
})
/**
 * Handles popups and dialogs triggered by menu item clicks
 */
export class MenuItemPopoverDirective implements OnDestroy, OnChanges{
  @Input() items:NbMenuItem[];
  private currentOverlayRef: OverlayRef | null = null;
  private backdropSubscription: Subscription | null = null;

  private destroy$ = new Subject<void>()
  constructor(
    private menuService:NbMenuService,
    private elRef:ElementRef,
    private overlayService: NbOverlayService,
    private positionBuilder: NbPositionBuilderService,
    private viewContainerRef: ViewContainerRef,
    private popoverService:PopoverService,
    private dialogService:NbDialogService
  ) { 
    this.menuService.onItemClick()
      .pipe(takeUntil(this.destroy$))
      .subscribe((menuBag) => {
        let menuTag = menuBag.tag;
        if(menuTag && menuTag === "sectionEditorMenu"){
          console.log(menuBag)
          let isDialog = this.checkDialogPopup(menuBag)
          if(isDialog){
            this.showDailog(menuBag)            
          }else{
            this.showPopover(menuBag);
          }
        }
      })
  }
  /**
   * 
   * @param menuBag 
   * @returns true if type is Dialog
   */
  checkDialogPopup(menuBag):boolean{
    let isDialog = false;
    let item = menuBag.item;
    if(item && item.data){
      let type = item.data.type?item.data.type:undefined
      if(type != undefined && type === "dialog"){
        isDialog = true
      }
    }
    return isDialog
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["items"]){
      console.log(this.items);
      const el = this.elRef.nativeElement;
      console.log(el)
    }
  }

  // Method to show popover with better positioning
    showPopover(menuBag: NbMenuBag) {
      let popoverComponent:any;
      let popoverContext:any;
      let popoverData:any;
      console.log(menuBag);
      let itemData = menuBag.item?.data;
      if(itemData){
        popoverData = itemData.popoverData != undefined ? itemData.popoverData : menuBag.item?.data;
        //Add context to popoberData if it exists as a separate property of data
        if(itemData.context != undefined){
          popoverData.content = itemData.context;
        }
        console.log(popoverData);
        // Close any existing popover
        if (this.currentOverlayRef) {
          this.currentOverlayRef.dispose();
          this.currentOverlayRef = null;
        }
        popoverComponent = this.popoverService.getPopoverComponent(popoverData.popoverType);
        popoverContext = this.popoverService.getPopoverContext(popoverData);
      }
      //const popoverData = menuBag.item?.data?.popoverData != undefined ? menuBag.item.data.popoverData : menuBag.item?.data;
      
      
      
      //
      
      
      if (popoverComponent) {
        // Try to find the clicked menu item element
        console.log({popoverComponent:popoverComponent,popoverContext:popoverContext})
        const menuElement:HTMLElement = this.elRef?.nativeElement;
        console.log(menuElement)
        let targetElement:ElementRef = this.elRef?.nativeElement;//menuElement;
        
        if (menuElement) {
          // Try to find the specific menu item that was clicked
          const menuItems = menuElement.querySelectorAll('.menu-item');
          
          const clickedIndex = this.items.findIndex(item => item.title === menuBag.item.title);
          console.log(menuItems,clickedIndex)
          if (clickedIndex >= 0 && menuItems[clickedIndex]) {
            //const clickedIndexEl = menuItems[clickedIndex];
            targetElement = menuItems[clickedIndex] as any;
          }
        }
        console.log("Target Element:", targetElement);
        const positionStrategy = this.positionBuilder
        .connectedTo(targetElement)
        .position(NbPosition.RIGHT)
        .adjustment(NbAdjustment.CLOCKWISE);

        // Create the overlay
        this.currentOverlayRef = this.overlayService.create({
          positionStrategy,
          hasBackdrop: true,
          backdropClass: 'cdk-overlay-transparent-backdrop',
        });
        //this.currentOverlayRef = this.overlayService.create(overlayRef);
  
        // Set the context properties on the component instance
        this.backdropSubscription = this.currentOverlayRef.backdropClick().subscribe(() => {
          //this.currentOverlayRef.dispose();
          this.closePopover();
        });
  
        const portal = new ComponentPortal(popoverComponent, this.viewContainerRef);
        const componentRef = this.currentOverlayRef.attach(portal);
        //const componentRef = this.viewContainerRef.createComponent(currentComponent);
        //(<SlideDataInteface>componentRef.instance).data = {type:"multi",slide:this.kwRenderSlide.slide};
        console.log(popoverContext);
        Object.assign(componentRef.instance, popoverContext);
        console.log(componentRef)
  
        // Attach the component to the overlay
        //this.currentOverlayRef.attach(componentRef.hostView);
  
        // Handle backdrop clicks to close popover
        /* this.currentOverlayRef.backdropClick().subscribe(() => {
          if (this.currentOverlayRef) {
            this.currentOverlayRef.dispose();
            this.currentOverlayRef = null;
          }
        }); */
  
        // Handle component destruction
        componentRef.onDestroy(() => {
          if (this.currentOverlayRef) {
            this.currentOverlayRef.dispose();
            this.currentOverlayRef = null;
          }
        });
      }
    }

    showDailog(menuBag){
      let item = menuBag.item;
      let popoverComponent:any;
      if(item && item.data){
        let popoverData = item.data.popoverData?item.data.popoverData:undefined;
        console.log(popoverData)
        if(popoverData != undefined){
          let popoverType = popoverData.popoverType;
          console.log(popoverType)
          popoverComponent = this.popoverService.getPopoverComponent(popoverType)
          this.dialogService.open(popoverComponent, {
            context: {
              title: popoverData.title,
              service:popoverData.service,
              property:popoverData.property,
              target:popoverData.target
            },
          });
        }
      }

         /* imageDialog(){
             this.dialogService.open(SampleImageDirectoryComponent, {
               context: {
                 title: 'Gallery',
               },
             });
           } */ 
    }


  private closePopover() {
    console.log("Closing popoover");
    if (this.backdropSubscription) {
      this.backdropSubscription.unsubscribe();
      this.backdropSubscription = null;
    }
    
    if (this.currentOverlayRef) {
      this.currentOverlayRef.dispose();
      this.currentOverlayRef = null;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    //this.closePopover();
  }

}
